'use strict';

function initCompTabs () {
  return $('.comp-tabs:not(.binded)').each(function () {
    var tabsBar = $(this).addClass('binded');
    var tabs = tabsBar.find('a.tab');
    var tabsContent = tabsBar.nextAll('.tab-content');

    $(tabs[0]).addClass('active');
    $(tabsContent[0]).addClass('active');
    return tabs.on('click', function (event) {
      var clicked = $(this);
      var activeIndex;

      event.preventDefault();

      if (clicked.hasClass('active')) {
        return;
      }

      tabs.removeClass('active');
      clicked.addClass('active');
      activeIndex = tabs.index(clicked);
      tabsContent.removeClass('active');
      return $(tabsContent[activeIndex]).addClass('active');
    });
  });
}

module.exports = initCompTabs;
